<template>
  <div class="homePage">
    <HomeHeader :showChooseCompany="true"></HomeHeader>
    <div class="contentArea">
      <!-- <div class="leftLayout">
        <div class="noticeList">
          <p class="title">待办通知</p>
          <div class="cells" :style="'height:'+noticeHeight+'px;'">

            <div class="cell" v-for="(item,index) in messageList" :key="index" @click="messageJump(item)">
              <div class="left">
                <img :src="item.iconUrl?item.iconUrl:defaultPng" alt="">
                <span>{{item.serviceName}}</span>
              </div>
              <span class="notice" v-if="item.msgValue">{{item.msgValue}}</span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- 左侧应用中心 -->
      <div class="leftLayout">
        <div class="topApp" ref="topApp">
          <div class="btn-left" @click="preClick()" v-if="productTotalRows > 1 && currentPage > 1">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="btn-right" @click="nextClick()" v-if="productTotalRows > 1 && currentPage !== productTotalRows">
            <i class="el-icon-arrow-right"></i>
          </div>
          <p class="title">应用中心</p>
          <div class="appBox">
            <div
              class="oneApp"
              v-for="(item, index) in productsMenu.slice((currentPage - 1) * 6, currentPage * 6)"
              :key="index"
              @click="platformJump(item)"
            >
              <img :src="item.iconUrl ? item.iconUrl : defaultPng" alt="" />
              <div>
                <p class="p1">{{ item.productName }}</p>
                <p class="p2">{{ item.productDesc }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧消息管理 -->
      <div class="rightLayout">
        <div class="common-tab-box">
          <div class="common-tab-left">
            <div
              :class="tabIndex == index ? 'common-tab-list common-tab-active' : 'common-tab-list'"
              v-for="(item, index) in tabList"
              :key="index"
              @click="tabClick(item, index, 'page')"
            >
              {{ item.tabName }}({{ index == 0 ? dealTotalRows>99?'99+':dealTotalRows : messageTotalRows>99?'99+':messageTotalRows }})
            </div>
          </div>
          
          <div class="common-tab-right" >
            <span v-if="messageType=='2'" @click="messageAllRead">
              <img src="../../assets/icon/all-read.png" alt="">
              全部已读 </span> 
            <span @click="expandMore"> 更多</span>
            <!-- <el-popover
              popper-class="popper-class-home"
              placement="right-end"
              width="450"
              ref="popover"
              trigger="click">
              <div class="hover-title">
                <span>通知中心222</span>
                <i class="el-icon-close" @click="hidePopover"></i>
              </div>
              <div class="common-tab-box">
                <div class="common-tab-left">
                  <div
                    :class="tabHoverIndex == index ? 'common-tab-list common-tab-active' : 'common-tab-list'"
                    v-for="(item, index) in tabList"
                    :key="index"
                    @click="tabClick(item, index,'hover')"
                  >
                    {{ item.tabName }}({{ index == 0 ? dealTotalRows : messageTotalRows }})
                  </div>
                </div>
              </div>
              <div class="notice-hover-box">
                <div
                  class="notice-list"
                  @click="messageJumpHover(item)"
                  v-for="(item, index) in messageAllList"
                  :key="index"
                >
                  <div class="notice-list-left"><span :style="item.isFinish !== 'Y' ? 'background:#fb2323;':'#fff' "></span><span>{{ item.title || '-' }}</span></div>
                  <div class="notice-list-center">{{ item.content || '-' }}</div>
                  <div class="notice-list-right">{{ item.createTime | getTime }}</div>
                </div>
              </div>
              <p class="no-data" v-show="messageAllList.length == 0">暂无数据</p>
              <el-pagination
                class="pt pb back-color-fff t-center"
                background
                @current-change="handleCurrentChange"
                :current-page="msgPage.pageIndex"
                :page-size="msgPage.pageSize"
                layout="total,  prev, pager, next"
                :total="msgPage.totalRows"
                small
              >
              </el-pagination>
            </el-popover> -->
          </div>
        </div>
        <!-- 待办 -->
        <div
          class="notice-list"
          @click="messageJump(item)"
          v-show="tabIndex == 0"
          v-for="(item, index) in dealList"
          :key="index"
        >
          <div class="notice-list-left">
            <span :style="item.isFinish !== 'Y' ? 'background:#fb2323;' : '#fff'"></span
            ><span>{{ item.content || '-' }}</span>
          </div>
          <div class="notice-list-right">{{ item.createTime | getTime }}</div>
        </div>
        <p class="no-data" v-show="tabIndex == 0 && dealList.length == 0">暂无数据</p>
        <!-- 消息 -->
        <div
          class="notice-list"
          @click="messageRemark(item)"
          v-show="tabIndex == 1"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <div class="notice-list-left">
            <span :style="item.isFinish !== 'Y' ? 'background:#fb2323;' : '#fff'"></span
            ><span>{{ item.content || '-' }}</span>
          </div>
          <div class="notice-list-right">{{ item.createTime | getTime }}</div>
        </div>
        <p class="no-data" v-show="tabIndex == 1 && messageList.length == 0">暂无数据</p>
      </div>
    </div>
    <!-- 报表 -->
    <div class="reportLayout">
      <div class="common-tab-box" v-if="reportList && reportList.length > 1">
        <div class="common-tab-left">
          <div
            :class="reportTabIndex == index ? 'common-tab-list common-tab-active' : 'common-tab-list'"
            v-for="(item, index) in reportList"
            :key="index"
            @click="reportTabClick(item, index)"
          >
            {{ item.menuName }}
          </div>
        </div>
      </div>
      <div class="report-content" v-if="reportPath">
        <iframe :src="reportPath" :style="{ height: BiHeight + 'px' }" class="iframe-sty" id="iframe"></iframe>
      </div>
    </div>
    <el-drawer
      title="通知中心"
      :visible.sync="drawer"
      direction="rtl"
      :with-header="false"
      :modal="false"
      custom-class="popper-class-home"
      width="450px"
    >
      <div class="hover-title">
        <span>通知中心</span>
        <i class="el-icon-close" @click="drawer = false"></i>
      </div>
      <div class="common-tab-box">
        <div class="common-tab-left">
          <div
            :class="tabHoverIndex == index ? 'common-tab-list common-tab-active' : 'common-tab-list'"
            v-for="(item, index) in tabList"
            :key="index"
            @click="tabClick(item, index, 'hover')"
          >
            {{ item.tabName }}({{ index == 0 ? dealTotalRows>99?'99+':dealTotalRows : messageTotalRows>99?'99+':messageTotalRows }})
          </div>
          
        </div>
        <div class="common-tab-right" >
          <span v-if="msgPage.messageType=='2'" @click="messageAllRead">
          <img src="../../assets/icon/all-read.png" alt="">
          全部已读 </span>
        </div>
      </div>
      <div class="notice-hover-box">
        <div class="notice-list" @click="messageJumpHover(item)" v-for="(item, index) in messageAllList" :key="index">
          <div class="notice-list-left">
            <span :style="item.isFinish !== 'Y' ? 'background:#fb2323;' : '#fff'"></span
            ><span>{{ item.title || '-' }}</span>
          </div>
          <div class="notice-list-center">{{ item.content || '-' }}</div>
          <div class="notice-list-right">{{ item.createTime | getTime }}</div>
        </div>
      </div>
      <p class="no-data" v-show="messageAllList.length == 0">暂无数据</p>
      <el-pagination
        class="pt pb back-color-fff t-center"
        background
        @current-change="handleCurrentChange"
        :current-page="msgPage.pageIndex"
        :page-size="msgPage.pageSize"
        layout="total,  prev, pager, next"
        :total="msgPage.totalRows"
        pager-count="3"
        small
      >
      </el-pagination>
    </el-drawer>
  </div>
</template>
<script>
import newEcharts from 'echarts';
import { JSEncrypt } from 'jsencrypt';
import HomeHeader from '@/components/homeHeader.vue';
import 'echarts/map/js/china';
import { DomainNameMap } from '@/api/apiRoute.js';
export default {
  name: 'marketingDigitalPlatform',
  components: {
    HomeHeader,
  },
  data() {
    return {
      defaultPng: require('../../assets/icon3.png'),
      currentTenantGuid: null,
      currentStaffGuid: null,
      // companyOption: [],
      organisationName: '--',
      positionName: '--',
      tenantName: '',
      messageList: [], //消息
      dealList: [], //待办
      productsMenu: [], //产品
      noticeHeight: 0,
      tabIndex: 0,
      tabList: [{ tabName: '待办' }, { tabName: '消息' }],
      messageType: '1', //消息类型 1待办 2消息
      dealTotalRows: 0,
      messageTotalRows: 0,
      reportList: [], //报表
      reportTabIndex: 0,
      reportPath: null,
      currentPage: 1,
      productTotalRows: 0,
      BiHeight: 1000,
      //hover消息
      tabHoverIndex: 0,
      messageHoverType: '1', //消息类型 1待办 2消息
      msgPage: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        messageType: '1',
        tenantGuid: null,
        staffGuid: null,
        isFinish: 'N',
        appSideName:'运营端'
        
      },
      messageAllList: [],
      drawer: false,
      showAllRead:false
    };
  },
  created() {
    document.title = '个人中心';
    if (localStorage.reportMenuList) {
      let reportMenuList = JSON.parse(localStorage.reportMenuList);
      if (reportMenuList && reportMenuList.length > 0) {
        this.reportList = reportMenuList;
        // menuList.forEach(i=>{
        //   if(i.menuName == '主页' ){
        //     this.reportList = i.children || [];
        //   }
        // })
      }
    }
    let userInfo = JSON.parse(localStorage.userInfo);
    if (userInfo.organisationNames) {
      this.organisationName = userInfo.organisationNames.join('，');
    }
    if (userInfo.positionNames) {
      this.positionName = userInfo.positionNames.join('，');
    }
    this.tenantName = userInfo.tenantName;
    this.currentStaffGuid = userInfo.staffGuid;
    this.currentTenantGuid = this.$store.state.guid;
    this.getOrgAndProduct();
    this.createServerConnect();
    //this.getCurrentuser();
  },
  mounted() {
    this.noticeHeight = window.innerHeight - 170;
  },
  methods: {
    // getCurrentuser() {
    //   let self = this;
    //   self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`).then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //           if (res.data.data != null && res.data.data != '') {
    //               this.companyOption = res.data.data;
    //           }
    //       } else {
    //           self.$message.error(res.data.msg);
    //       }
    //   });
    // },
    receiveMessage(event) {
      this.BiHeight = event.data.data ? event.data.data.height  : 1000;
      // console.log('BI高度接收', event);
      // ...
    },
    tabClick(item, index, type) {
      if (type == 'page') {//页面的点击
        this.tabIndex = index;
        this.messageType = index == 0 ? '1' : '2';
        if (index == 0) {
          this.showAllRead=false
          this.getDealtList();
        } else {
          this.showAllRead=true
          this.getMessageList();
        }
      } else {//抽屉里面的点击
        if (index == 0) {
          this.showAllRead=false
          this.getDealtList();
        } else {
          this.showAllRead=true
          this.getMessageList();
        }
        this.tabHoverIndex = index;
        this.msgPage.messageType = index == 0 ? '1' : '2';
        this.getAllMessageList();
      }
    },
     // 更多
     expandMore(){
      this.tabHoverIndex = this.messageType == '1' ? 0 : 1;
      this.msgPage.messageType = this.messageType ;
      this.drawer = true;
      this.getAllMessageList()
    },
    reportTabClick(item, index) {
      let userInfo = JSON.parse(localStorage.userInfo);
      this.reportTabIndex = index;
      let loginInfo = JSON.stringify({
        username: 'ExternalAccount',
        pwd: 'd70413d70ad4af480fa4c6952ab8edb3',//正式
        // pwd: '21232f297a57a5a743894a0e4a801fc3',//测试
        timestamp: new Date().getTime()
      })
      // let path = 'http://localhost:8093/Look?pageGuid=8acd011d7ae24b5099f88f669b331a2b';
      this.reportPath = `${item.path}&loginInfo=${encodeURI(this.encrypt(loginInfo))}&tenantGuid=${this.currentTenantGuid}&staffGuid=${userInfo.staffGuid}&hasScrollbar=false`;
      console.log('first', this.reportPath);
      window.addEventListener('message', this.receiveMessage);
    },
    preClick() {
      this.currentPage = this.currentPage - 1;
    },
    nextClick() {
      this.currentPage = this.currentPage + 1;
    },
    //隐藏hover消息
    hidePopover() {
      this.$refs.popover.doClose();
    },
    //获取消息列表
    getMessageList() {
      let query = {
        messageType: 2,
        pageIndex: 1,
        pageSize: 4,
        tenantGuid: this.currentTenantGuid,
        staffGuid: this.currentStaffGuid,
        isFinish: 'N',
        appSideName:'运营端',
      };
      this.api.postJson(`/${serverConfig.msConfigureService}/message/data/get-message-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.messageList = res.data.data.records || [];
          this.messageTotalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取待办列表
    getDealtList() {
      let query = {
        messageType: 1,
        pageIndex: 1,
        pageSize: 4,
        tenantGuid: this.currentTenantGuid,
        staffGuid: this.currentStaffGuid,
        isFinish: 'N',
        appSideName:'运营端',
      };
      this.api.postCan(`/${serverConfig.msConfigureService}/message/data/get-message-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.dealList = res.data.data.records || [];
          this.dealTotalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //hover获取所有消息列表
    getAllMessageList() {
      this.msgPage.tenantGuid = this.currentTenantGuid;
      this.msgPage.staffGuid = this.currentStaffGuid;
      this.api
        .postJson(`/${serverConfig.msConfigureService}/message/data/get-message-list`, this.msgPage)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.messageAllList = res.data.data.records || [];
            this.msgPage.totalPage = res.data.data.totalPages;
            this.msgPage.totalRows = res.data.data.totalRows;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //消息已读
    messageRemark(item) {
      this.api.postJson(`/${serverConfig.msConfigureService}/message/data/update-state`, [item.guid]).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // this.$message.success('标记成功！');
          // this.getMessageList();
          this.messageJump(item);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //消息全部已读
    messageAllRead(type) {
      this.$confirm('确定全部标记为已读吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
      // '确定全部标记为已读吗？'
        this.api.put(`/${serverConfig.msConfigureService}/message/update-all-finish?staffGuid=${this.currentStaffGuid}`).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('操作成功！');
            this.getMessageList();
            this.getAllMessageList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      })
    },
    //hover时的效果
    messageJumpHover(item) {
      if (item.messageType == '1') {
        this.messageJump(item);
      } else {
        this.messageRemark(item);
      }
    },
    getDomainName() {
      const systemEnvironment = localStorage.systemEnvironment; // 后端环境
      console.log('systemEnvironment',systemEnvironment)
      const domainName = DomainNameMap[systemEnvironment] || '';
      console.log('domainName',domainName)
      // 检测是否为本地环境
      const isLocal = location.hostname === 'localhost' || location.hostname === '192.168.10.17';
      const targetDomain = isLocal ? location.origin : domainName;
      console.log('targetDomain',targetDomain)
      return targetDomain;
    },
    //消息待办跳转
    messageJump(pObject) {
      // this.api
      //   .get(
      //     `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${this.currentTenantGuid}&appSideIdentifier=scm_operative`,
      //   )
      //   .then((res) => {
      //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //       this.menuList = res.data.data;
      //       if (res.data.data[0].menuName == '主页') {
      //         //有个人首页，导航不显示个人主页菜单，直接跳转
      //         this.menuList = this.menuList.slice(1);
      //       }
      //       localStorage.setItem('menuList', JSON.stringify(this.menuList));
      //       if (pObject.jumpUrl.indexOf('?') > -1) {
      //         window.open(location.origin + pObject.jumpUrl + '&productGuid=' + pObject.productGuid);
      //       } else {
      //         window.open(location.origin + pObject.jumpUrl + '?productGuid=' + pObject.productGuid);
      //       }
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //   });

      let userInfo = JSON.parse(localStorage.userInfo);
      let req = {
        "tenantGuid": this.currentTenantGuid,
        "appSideGuid": '03cb364e04d894a44cdb94273abffa13',
        "userGuid": userInfo.userGuid,
        "menuPath": pObject.jumpUrl
      }
      const targetDomain = this.getDomainName();
      
       this.api
        .postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get-product-guid`,req)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log(res.data)
            let productGuid = res.data.data;
            // if (pObject.jumpUrl.indexOf('?') > -1) {
            //   window.open(targetDomain + pObject.jumpUrl + '&productGuid=' + productGuid);
            // } else {
            //   window.open(targetDomain + pObject.jumpUrl + '?productGuid=' + productGuid);
            // }
            let url = `${targetDomain}/LoginAccess?tenantGuid=${this.currentTenantGuid}&username=${this.$route.query.username}&password=${this.$route.query.password}&productGuid=${productGuid}&path=${encodeURIComponent(pObject.jumpUrl)}&logoTitle=${this.$route.query.logoTitle}&token=${localStorage.token}&refreshToken=${localStorage.refreshToken}`
            window.open(url)
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    msgMore() {
      window.open(
        location.origin +
          '/messageManagementList?staffGuid=' +
          this.currentStaffGuid +
          '&tenantGuid=' +
          this.currentTenantGuid,
      );
    },
    //应用跳转
    platformJump(pObject) {
      // 应用路由存在
      console.log('pObject',pObject);
      
      let self = this
      if (pObject.productRoute) {//设置了产品路由
        let reqUrl = ''
        if (pObject.productGuid) {
          reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${this.currentTenantGuid}&productGuid=${pObject.productGuid}&appSideIdentifier=scm_operative`;
        } else {
          reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${this.currentTenantGuid}&appSideIdentifier=scm_operative`;
        }
        self.api.get(reqUrl).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            localStorage.setItem(
              "wynToken",
              JSON.stringify(
                "670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef"
              )
            );
            self.menuList = res.data.data;
            if (res.data.data[0].menuName == "主页") {
              //有个人首页，导航不显示个人主页菜单，直接跳转
              self.menuList = self.menuList.slice(1);
            }
            
            
            localStorage.setItem("menuList", JSON.stringify(self.menuList));
            if (
              self.menuList[0].children != null &&
              self.menuList[0].children.length > 0
            ) {
              setTimeout(function () {
                if (pObject.productGuid) {
                  window.open(
                    pObject.productRoute + self.menuList[0].children[0].path
                  );
                }
              }, 200);
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        this.getMenuList(pObject.productGuid);
      }
    },
    //获取应用产品菜单并跳转
    getMenuList(productGuid) {
      let self = this;
      var reqUrl;
      const targetDomain = self.getDomainName();
      const url = `${targetDomain}/LoginAccess?tenantGuid=${this.currentTenantGuid}&username=${self.$route.query.username}&password=${self.$route.query.password}&productGuid=${productGuid}&logoTitle=${self.$route.query.logoTitle}&token=${localStorage.token}&refreshToken=${localStorage.refreshToken}`
      window.open(url)
      return
      if (productGuid) {
        reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${this.currentTenantGuid}&productGuid=${productGuid}&appSideIdentifier=scm_operative`;
      } else {
        reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${this.currentTenantGuid}&appSideIdentifier=scm_operative`;
      }
      self.api.get(reqUrl).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          localStorage.setItem(
            'wynToken',
            JSON.stringify('670550ae1460a86607190cd98b36eea4dcf0069a7e9d1f8c3af08b4b6936e6ef'),
          );
          self.menuList = res.data.data;
          if (res.data.data[0].menuName == '主页') {
            //有个人首页，导航不显示个人主页菜单，直接跳转
            self.menuList = self.menuList.slice(1);
          }
          self.menuList.forEach(function (i, idx) {
            if (i.externalLinkMark == '01') {
              i.src = i.path;
              i.path = '/reportQueryList-' + idx;
              console.log('1', i.externalLinkMark);
              if (i.children != null && i.children != '') {
                i.children.forEach(function (j, index) {
                  index = index + 1;
                  if (j.externalLinkMark == '01') {
                    console.log('11', j.externalLinkMark);
                    j.src = j.path;
                    j.path = '/reportQuery-' + idx + index + '?productGuid=' + productGuid;
                  }
                });
              }
            }
          });
          localStorage.setItem('menuList', JSON.stringify(self.menuList));
          if (self.menuList[0].children != null && self.menuList[0].children.length > 0) {
            setTimeout(function () {
              if (productGuid && self.menuList[0].children[0].path.indexOf('reportQuery') == -1) {
                window.open(targetDomain + self.menuList[0].children[0].path + '?productGuid=' + productGuid);
              } else {
                window.open(targetDomain + self.menuList[0].children[0].path);
              }
            }, 200);
          } else {
            self.$router.push('/reportQueryList-0?productGuid=' + productGuid);
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取当前公司下的菜单
    getOrgAndProduct() {
      this.api
        .get('/ms-personnel-service/staff-home/org-and-product?staffGuid=' + this.currentStaffGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.organisationName = res.data.data.organisationName;
            this.positionName = res.data.data.positionName;
            this.productsMenu = res.data.data.products;
            this.productTotalRows = Math.ceil(this.productsMenu.length / 6);
            this.productsMenu.forEach((item) => {
              if (item.icon) {
                let obj = JSON.parse(item.icon);
                this.$set(item, 'iconUrl', obj.path);
              }
            });
            if (this.reportList && this.reportList.length > 0) {
              let userInfo = JSON.parse(localStorage.userInfo);
              let loginInfo = JSON.stringify({
                username: 'ExternalAccount',
                pwd: 'd70413d70ad4af480fa4c6952ab8edb3',//正式
                // pwd: '21232f297a57a5a743894a0e4a801fc3',//测试
                timestamp: new Date().getTime()
              })
              // let path = 'http://43.254.3.69:3061/Look?pageGuid=3b925cdebec745dc869a11d6c394d979';
              this.reportPath = `${this.reportList[0].path}&loginInfo=${encodeURI(this.encrypt(loginInfo))}&tenantGuid=${this.currentTenantGuid}&hasScrollbar=false&staffGuid=${userInfo.staffGuid}`;
            }
            window.addEventListener('message', this.receiveMessage);
            console.log(this.reportPath);
            this.getDealtList();
            this.getMessageList();
            this.getAllMessageList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      let self = this;
      self.msgPage.pageIndex = val;
      this.getAllMessageList();
    },
    createServerConnect(){
      const that = this;
      const websocketUrl = location.href.indexOf('https://scm-operation.csyaoly') > -1 ? 'websocket-product.cs4pl.com' : location.href.indexOf('https://scm-operation.cs4pl.com') > -1 ? 'websocket-pre-product.cs4pl.com' : location.href.indexOf('https://scm-operation-test.csbr.cn') > -1 ? 'websocket.cs4pl.com' : 'websocket-pre.cs4pl.com'
      const ws = new WebSocket(`wss://${websocketUrl}/websocket/${this.currentStaffGuid}`);
      ws.onopen = function() {
        console.log('Connected to server.');
      };
      ws.onmessage = function(res) {
        if (res.data == '\"连接成功\"') return;
        that.getOrgAndProduct();
      };
    },
    encrypt(txt) {
      let encryptor = new JSEncrypt()
      let publicKey = '-----BEGIN PUBLIC KEY-----MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgFiv3Ko6rOBvWDK96tIExpdyuuQAGgZo0YmQxpT10hD3qu/MnNKlIJgo4+NwUHcwpleKE2DBOxgvCeMtUoP4FDWt8q18X+4+7t8p0D/57NhA0liNKQ/Ise6b5i293ht1XPen3XhR5xIcDNxauQ5vKqdwwzhoonsbJDtbowoinLQbAgMBAAE=-----END PUBLIC KEY-----';
      encryptor.setPublicKey(publicKey) // 设置公钥
      return encryptor.encrypt(txt); // 对数据进行加密
    },
  },
};
</script>

<style scoped>
.topApp p,
.noticeList p {
  padding: 0;
  margin: 0;
}
.homePage {
  background: #f6f7fa;
  height: 100vh;
  overflow: auto;
  width: 100%;
  padding: 0.8rem 1rem 1rem 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.logoArea {
  display: flex;
  align-items: flex-end;
  padding-bottom: 1.5rem;
}

.logoArea img {
  height: 2.125rem;
  margin-right: 1.875rem;
}

.logoArea span {
  font-size: 1.25rem;
  color: #323233;
}

.contentArea {
  display: flex;
  /* flex: 1; */
  /* height: 270px; */
  width: 100%;
  /* background: #fff; */
}

/* 左侧 */
.leftLayout {
  width: 70%;
  min-height: 270px;
  flex-shrink: 0;
  /* padding-left: 1rem; */
  margin-right: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.topApp {
  height: 270px;
  position: relative;
  background: #fff;
  padding: 1.25rem 1.5rem 0.25rem 1.5rem;
  box-sizing: border-box;
}
.topApp .title {
  font-size: 1.1rem;
  color: #323233;
  /* border-bottom: 1px solid #DFE1E6; */
  /* margin-bottom: 1rem; */
  padding-left: 10px;
  padding-bottom: 1rem;
  text-align: left;
  font-weight: 500;
}

.topApp .appBox {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}

.topApp .oneApp {
  width: 32%;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  text-align: left;
  /* background: #F6F7FA; */
  border: 1px solid #d9d9d9;
  margin-right: 2%;
  margin-bottom: 1rem;
  cursor: pointer;
  border-radius: 4px;
  box-sizing: border-box;
}
.topApp .oneApp:nth-child(3n) {
  margin-right: 0;
}
.topApp .oneApp:hover {
  background: #fafafa;
  transition: all 0.5s;
  box-shadow: 0px 0 0.625rem 3px rgba(0, 0, 0, 0.1);
}

.topApp .oneApp img {
  width: 3rem;
  height: 3rem;
  margin-right: 1rem;
}

.topApp .oneApp .p1 {
  font-size: 1.1rem;
  margin-bottom: 4px;
  font-weight: 400;
}

.topApp .oneApp .p2 {
  font-size: 0.8rem;
  color: #6e6e6e;
}
.topApp i {
  font-size: 18px;
  color: #fff;
}
.btn-left {
  position: absolute;
  top: 120px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 40px;
  opacity: 0.25;
  background: #000000;
  border-radius: 2px;
  cursor: pointer;
}
.btn-right {
  position: absolute;
  top: 120px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 40px;
  opacity: 0.25;
  background: #000000;
  border-radius: 2px;
  cursor: pointer;
}
.btn-right:hover {
  opacity: 0.45;
}
.btn-left:hover {
  opacity: 0.45;
}
/* 右侧 */
.rightLayout {
  width: calc(30% - 4px);
  /* height: 100%; */
  flex: 1;
  background: #fff;
}
.rightLayout .notice-list,
.notice-hover-box .notice-list {
  display: flex;
  justify-content: space-between;
  padding: 4px 16px;
  line-height: 25px;
  box-sizing: border-box;
}
.rightLayout .notice-list:hover,
.notice-hover-box .notice-list:hover {
  background: #fafafa;
  cursor: pointer;
}
.rightLayout .notice-list-left,
.notice-hover-box .notice-list-left {
  display: flex;
  flex: 1;
  text-align: left;
}
.rightLayout .notice-list-left span:first-child,
.notice-hover-box .notice-list-left span:first-child {
  float: left;
  flex-shrink: 0;
  display: block !important;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 8px;
  margin-top: 10px;
}
.rightLayout .notice-list-left span:last-child {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.notice-hover-box .notice-list-left span:last-child {
  display: -webkit-box !important;
}
.notice-list-right,
.notice-hover-box .notice-list-right {
  font-size: 12px;
  flex-shrink: 0;
  padding-left: 10px;
}
.notice-hover-box .notice-list {
  display: block;
  text-align: left;
  border-bottom: 1px solid #d9d9d9;
}
.notice-hover-box .notice-list-center {
  font-size: 12px;
  color: #666;
  padding-left: 13px;
}
.notice-hover-box .notice-list-right {
  color: #999999;
  padding-left: 13px;
}
.hover-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  margin: 10px 0;
}
.hover-title span {
  display: block;
  font-size: 16px;
}
.hover-title i {
  font-size: 20px;
  cursor: pointer;
}
/* 页面tab */
.common-tab-box {
  display: flex;
  justify-content: space-between;
  height: 32px;
  line-height: 32px;
  color: #666;
  margin-top: 4px;
  /* margin: 16px 16px 4px 16px; */
  border-bottom: 1px solid #e5e5e5;
  outline: none;
  background: #fff;
}
.common-tab-left {
  display: flex;
}
.common-tab-list {
  padding: 0 20px;
  /* margin: 0 5px; */
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.common-tab-active {
  color: #4fa1a4;
  border-bottom: 2px solid #4fa1a4;
}
.common-tab-right {
  font-size: 12px;
  color: #666666;
  cursor: pointer;
  margin-right: 16px;
  
}
.common-tab-right img{
    width: 1rem;
    height: 1rem;
    vertical-align: text-bottom
  }
.no-data {
  color: #666;
  font-size: 12px;
  margin: 20px;
}
.iframe-sty {
  width: 100%;
  min-height: 100vh;
  border: none;
  /* background:grey; */
}
.report-content {
  margin-top: 4px;
}
.notice-hover-box {
  max-height: calc(100vh - 140px);
  overflow: auto;
}
.t-center {
  text-align: center;
}
/deep/ .el-drawer__body{
  padding: 0;
}
</style>
<style>
::-webkit-scrollbar {
  width: 10px !important;
}
.popper-class-home {
  position: absolute;
  width: 450px!important;
  height: 100vh;
  /* padding: 12px 0 !important; */
}
/* .scroller::-webkit-scrollbar-track {
  background-color:transparent;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius:2em;
}
.scroller::-webkit-scrollbar-thumb {
  background-color: rgb(147,147,153,0.5);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius:2em;
} */
</style>
